/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SimplePriceFromJSON, SimplePriceToJSON, } from './SimplePrice';
/**
 * Check if a given object implements the CommonBookingInfoViewBasketPriceBreakdown interface.
 */
export function instanceOfCommonBookingInfoViewBasketPriceBreakdown(value) {
    if (!('basePrice' in value) || value['basePrice'] === undefined)
        return false;
    if (!('processingFee' in value) || value['processingFee'] === undefined)
        return false;
    if (!('serviceFee' in value) || value['serviceFee'] === undefined)
        return false;
    if (!('totalPrice' in value) || value['totalPrice'] === undefined)
        return false;
    return true;
}
export function CommonBookingInfoViewBasketPriceBreakdownFromJSON(json) {
    return CommonBookingInfoViewBasketPriceBreakdownFromJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketPriceBreakdownFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'basePrice': SimplePriceFromJSON(json['base_price']),
        'processingFee': SimplePriceFromJSON(json['processing_fee']),
        'serviceFee': SimplePriceFromJSON(json['service_fee']),
        'totalPrice': SimplePriceFromJSON(json['total_price']),
    };
}
export function CommonBookingInfoViewBasketPriceBreakdownToJSON(json) {
    return CommonBookingInfoViewBasketPriceBreakdownToJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketPriceBreakdownToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'base_price': SimplePriceToJSON(value['basePrice']),
        'processing_fee': SimplePriceToJSON(value['processingFee']),
        'service_fee': SimplePriceToJSON(value['serviceFee']),
        'total_price': SimplePriceToJSON(value['totalPrice']),
    };
}
